import { useState, useEffect } from 'react';
import { getPortfolioData, fetchPortfolioData } from '../services/portfolioService';

// Check if we need to fetch from CDN (async) or use local data (sync)
const USE_CDN = false; // This should match the value in portfolioService.js

// Initialize data immediately if using local data
const initialData = USE_CDN ? null : getPortfolioData();

/**
 * Custom hook to get portfolio data
 * @returns {Object} { data, loading, error }
 */
export const usePortfolioData = () => {
  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(USE_CDN);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Only fetch if using CDN
    if (USE_CDN) {
      const loadData = async () => {
        try {
          setLoading(true);
          const portfolioData = await fetchPortfolioData();
          setData(portfolioData);
        } catch (err) {
          setError(err.message);
          console.error('Failed to load portfolio data:', err);
        } finally {
          setLoading(false);
        }
      };

      loadData();
    }
  }, []);

  return { data, loading, error };
};

